import { FeatureFlags } from '@aibees/elephant/types';
import { useAuthContext } from '@aibees/shared/auth';
import { UserRole } from '@aibees/shared/definition';
import { useFeatureFlagsContext } from '@aibees/shared/feature-flags';

export function useIsSmartleadIntegrationEnabled() {
  const { user } = useAuthContext();

  const hasSmartleadIntegrationRole = user?.roles?.includes(
    UserRole.ElIntgrtonSmtLead
  );

  const isSmartleadIntegrationEnabled =
    useFeatureFlagsContext().isFeatureEnabled(
      FeatureFlags.INTEGRATION_SMARTLEAD
    );

  return isSmartleadIntegrationEnabled || hasSmartleadIntegrationRole;
}
